import React, { useEffect, useRef } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import {
  formatDate,
  formatFullDate,
  formatTime,
  getAvatar,
  getPlacement,
  getUsername,
} from "../helpers/utils";
import { hideTypingIndicator } from "../redux/chat/actions";
import { IConversationMessage } from "../types/webchatConversation";
import ChatItem from "./ChatItem";

const Chat: React.FC = () => {
  const chatMessages = useSelector(
    (state: RootStateOrAny) => state.ChatMessages,
  );
  const isTyping = useSelector(
    (state: RootStateOrAny) => state.typingIndicator,
  );
  const dispatch = useDispatch();
  const chatBottom = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => chatBottom?.current?.scrollIntoView(true);

  useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
    }, 10);
  }, [chatMessages]);

  // Sakrij typing indicator kada stigne nova poruka sa leve strane (bot/AI)
  useEffect(() => {
    if (chatMessages.length > 0 && isTyping) {
      const lastMessage = chatMessages[chatMessages.length - 1];
      const placement = getPlacement(lastMessage);
      // Ako je poslednja poruka sa leve strane (bot), sakrij typing indicator
      if (placement === "left") {
        dispatch(hideTypingIndicator());
      }
    }
  }, [chatMessages, isTyping, dispatch]);

  const numOfMsgs = chatMessages.length;

  return (
    <div className="chat">
      <ul className="overflow-auto conversation-list chat-ul">
        {chatMessages.map(
          (chatMessage: IConversationMessage, index: number) => {
            const dateString = formatDate(chatMessage.createdAt);
            const timeString = formatTime(chatMessage.createdAt);
            const userName = getUsername(chatMessage);
            const placement = getPlacement(chatMessage);
            const avatar = getAvatar(chatMessage);
            const last = index === numOfMsgs - 1;

            <li>
              <div id="chat-bottom-div" ref={chatBottom} />
            </li>;
            const showDate =
              index === 0 ||
              dateString !== formatDate(chatMessages[index - 1].createdAt);

            return (
              <span key={chatMessage._id ? chatMessage._id : index.toString()}>
                {showDate && (
                  <div style={{ textAlign: "center", margin: "10px" }}>
                    <span className="chatMessage-date">
                      {formatFullDate(chatMessage.createdAt)}
                    </span>
                  </div>
                )}
                <ChatItem
                  userName={userName}
                  avatar={avatar}
                  text={chatMessage.msg.text}
                  placement={placement}
                  time={timeString}
                  date={dateString}
                  type={chatMessage.type}
                  media={chatMessage.msg.media}
                  last={last}
                  keyboard={chatMessage.msg.keyboard}
                  notDelivered={chatMessage.notDelivered}
                  sentMsg={chatMessage.sentMsg}
                  printUsername={
                    index === 0 ||
                    getUsername(chatMessages[index - 1]) !== userName
                  }
                  msg={chatMessage.msg}
                />
              </span>
            );
          },
        )}
        {/* Typing indicator - sa leve strane (kao bot poruka) */}
        {isTyping && (
          <li className="clearfix chat-item-li">
            <div className="typing-indicator-container">
              <div className="typing-indicator">
                <span className="typing-dot"></span>
                <span className="typing-dot"></span>
                <span className="typing-dot"></span>
              </div>
            </div>
          </li>
        )}
        <li>
          <div id="chat-bottom-div" ref={chatBottom} />
        </li>
      </ul>
    </div>
  );
};

export default Chat;
